import { getSurvey } from '../../services/data-entry/surveys.service';
import { updateSurveyBuilder } from './dataEntrySurveyBuilderActions';

//Survey Preview list
export const UPDATE__SURVEY__PREVIEW_DATA = 'UPDATE__SURVEY__PREVIEW_DATA';
export const TOGGLE_SURVEY__PREVIEW_LIST_LOADING = 'TOGGLE_SURVEY__PREVIEW_LIST_LOADING';
export const MY_SURVEY__PREVIEW_LIST_ERROR = 'MY_SURVEY__PREVIEW_LIST_ERROR';

export const updateSurveyPreviewData = (value = []) => ({
  type: UPDATE__SURVEY__PREVIEW_DATA,
  payload: { name: 'data', value }
});

export const surveyPreviewError = (value = null) => ({
  type: MY_SURVEY__PREVIEW_LIST_ERROR,
  payload: { name: 'error', value }
});

export const toggleLoadingSurveyPreview = (value = false) => ({
  type: TOGGLE_SURVEY__PREVIEW_LIST_LOADING,
  payload: { name: 'loading', value }
});

export const loadSurveyPreview = (surveyId = '') => {
  return async (dispatch) => {
    try {
      dispatch(updateSurveyPreviewData({}));
      dispatch(toggleLoadingSurveyPreview(true));
      dispatch(surveyPreviewError());

      const { data } = await getSurvey(surveyId);

      if (data) {
        dispatch(updateSurveyPreviewData(data));
        dispatch(updateSurveyBuilder({ 'constraints': data?.data?.constraints || {} }));
        return;
      } else {
        dispatch(updateSurveyPreviewData(null));
      }
    } catch (error) {
      dispatch(updateSurveyPreviewData(null));
    } finally {
      dispatch(toggleLoadingSurveyPreview());
      dispatch(surveyPreviewError());
    }
  };
};
